import { Contact } from 'theSource/features/Contacts/types';

export const mapContactDeleteDto = (contact: Contact) => ({
  id: contact.id,
  modified_at: contact.updatedAt,
  updated_at: contact.updatedAt,
});
